/**
 * Session-scoped ID for observability. Regenerates when the browser tab/window is closed.
 */

import { v4 as uuidv4 } from 'uuid';

const SESSION_ID_KEY = 'observability_session_id';

let inMemorySessionId: string | null = null;

/**
 * Returns session_id (UUID v4). Stored in sessionStorage so it regenerates on browser close.
 * Falls back to in-memory if sessionStorage is unavailable (e.g. private browsing).
 * Safe to call before any async init.
 */
export function getSessionId(): string {
  if (typeof window === 'undefined') {
    return 'unknown';
  }
  try {
    if (typeof sessionStorage !== 'undefined') {
      let id = sessionStorage.getItem(SESSION_ID_KEY);
      if (!id || id.length < 30) {
        id = uuidv4();
        sessionStorage.setItem(SESSION_ID_KEY, id);
      }
      return id;
    }
  } catch {
    // sessionStorage may throw in private browsing
  }
  if (!inMemorySessionId) {
    inMemorySessionId = uuidv4();
  }
  return inMemorySessionId;
}
